import React from 'react'
import '../homeStyle.scss'

function HeroSection() {
  return (
    <div>
        <div className='main-wrapper'>
          <div className='home-hero-title'>
            <h1>Take every interaction to the next level.</h1>
          </div>
        </div>
        <div className='hero-img-wrap'>
          <div className='hero-img' onContextMenu={(e) => e.preventDefault()}>
            <div className='hero-inside-img'></div>
          </div>
        </div>
    </div>
  )
}

export default HeroSection